const apiService = {
  /**
   * Realiza una petición GET a la API
   * @param {string} methodName - Nombre del método o endpoint a llamar
   * @param {object} jsonData - Datos a enviar como parámetros de consulta (query params)
   * @returns {Promise<object>} - Respuesta de la API en formato JSON
   */
  get: async (methodName, jsonData = {}, user = {id_usuario: '', usuario:'', nombre: '', rol: ''}) => {
        const datos = {
            Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
            Ambiente: 'DESA',
            Dispositivo: {
              Marca: 'SAMSUNG',
              Modelo: 'S22002B',
              Version: 'Android 18.125',
              McAdress: null,
              PowerStatus: '84%',
              WifiStatus: 'Conected to iphone de Mauricio',
              GPSStatus: 'ON',
              GPS: '321|-485|321',
            },
            Usr: {
              Codigo: user.id_usuario.toString(),
              UserNickName:  user.usuario  ,
            },
            DatosMetodo: {
              NombreMetodo: methodName,
              Datos_Recibidos: JSON.stringify(jsonData),
            },
          };
           console.log("Metodo: ", methodName );
           console.log("Json Completo: ", JSON.stringify(datos));
           console.log("Json Interno: ", JSON.stringify(jsonData));
          const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
          const response = await fetch(fetchDataUrl);
          const data = await response.json(); 
          console.log("json Respuesta: ",  data)
      return data;
  },

  /**
   * Realiza una petición POST a la API
   * @param {string} methodName - Nombre del método o endpoint a llamar
   * @param {object} jsonData - Datos a enviar en el cuerpo de la petición
   * @returns {Promise<object>} - Respuesta de la API en formato JSON
   */
  post: async (methodName, jsonData = {}) => {
    const body = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321',
        },
        User: {
          Codigo: '0',
          UserNickName: 'pierril',
        },
        Metodo: {
          NombreMetodo: methodName,
          Datos_Recibidos: JSON.stringify(jsonData),
          Datos_Generados: ""
        },
      };
        const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });
        console.log("Metodo: ", methodName );
        console.log("Json Completo: ", JSON.stringify(body));
        console.log("Json Interno: ", JSON.stringify(jsonData));
        const data = await response.json();
        console.log('Respuesta del servidor:', data);
        return data
    },
    get_Test: async (methodName, jsonData = {}, user = {id_usuario: '', usuario:'', nombre: '', rol: ''}) => {
      const datos = {
          Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
          Ambiente: 'DESA',
          Dispositivo: {
            Marca: 'SAMSUNG',
            Modelo: 'S22002B',
            Version: 'Android 18.125',
            McAdress: null,
            PowerStatus: '84%',
            WifiStatus: 'Conected to iphone de Mauricio',
            GPSStatus: 'ON',
            GPS: '321|-485|321',
          },
          Usr: {
            Codigo: user.id_usuario.toString(),
            UserNickName:  user.usuario  ,
          },
          DatosMetodo: {
            NombreMetodo: methodName,
            Datos_Recibidos: JSON.stringify(jsonData),
          },
        };
         console.log("Metodo: ", methodName );
         console.log("Json Completo: ", JSON.stringify(datos));
         console.log("Json Interno: ", JSON.stringify(jsonData));
        const fetchDataUrl = `https://localhost:7190/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
        const response = await fetch(fetchDataUrl);
        const data = await response.json(); 
        console.log("json Respuesta: ",  data)
    return data;
},

/**
 * Realiza una petición POST a la API
 * @param {string} methodName - Nombre del método o endpoint a llamar
 * @param {object} jsonData - Datos a enviar en el cuerpo de la petición
 * @returns {Promise<object>} - Respuesta de la API en formato JSON
 */
post_test: async (methodName, jsonData = {}) => {
  const body = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: methodName,
        Datos_Recibidos: JSON.stringify(jsonData),
        Datos_Generados: ""
      },
    };
      const response = await fetch('https://localhost:7190/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      console.log("Metodo: ", methodName );
      console.log("Json Completo: ", JSON.stringify(body));
      console.log("Json Interno: ", JSON.stringify(jsonData));
      const data = await response.json();
      console.log('Respuesta del servidor:', data);
      return data
  },


  logactivity: async(pantalla,accion,datoscomplementarios,user) =>{
     const headers = {'Content-Type': 'application/json'};
    const det = JSON.stringify(datoscomplementarios);
    const body = JSON.stringify({
        "lau_codusu": user.id_usuario,
        "lau_pantalla": pantalla ,
        "lau_accion": accion,
        "lau_detalles": det,
        "lau_direccionIP": "",
        "lau_useragent": "",
        "lau_dispositivo": "" }) ;
        console.log("Datos Para API: ",body);
        const response = await fetch('https://appcorp.parma.com.gt/API/LogActivities', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify( body),
        });
        
        if (response.ok) {
          const data = await response.text();
          console.log(data);
        } else {
          console.log('Error:', response);
        }

  // const controller = new AbortController();
  // const timeoutId = setTimeout(() => controller.abort(), 5000); 

  // const response = await fetch('https://appcorp.parma.com.gt/API/LogActivities', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(body),
  //       })
  //       .then(response => response.json())
  //       .then(data => {
  //         console.log('Log registrado:', data);
  //       })
  //       .finally(() => {
  //         clearTimeout(timeoutId);
  //       });


  //       const data = await response.json();
  //       console.log('Respuesta del servidor:', data);
  }
  
};

export default apiService;